<template>
    <v-app>
        <v-container class="services" v-if="!hasResult">
            <v-layout xs8 md12 row wrap class="title-block">
                <services-breadcrumbs v-if="b2b"></services-breadcrumbs>
                <v-flex>
                    <h2>Поиск и проверка данных об автомобиле по базе ГИБДД</h2>
                </v-flex>
            </v-layout>
            <services-carousel
                v-if="!b2b"
                :slides="carouselSlides"
            />
            <services-request-form
                title="Введите VIN и мы покажем вам информацию"
                type="gibdd"
                :loading="loading"
                @find="find"
            />
        </v-container>
        <v-container class="services services-result" v-if="hasResult">
            <v-layout xs8 md12 row wrap class="title-block">
                <services-breadcrumbs v-if="b2b"></services-breadcrumbs>
                <v-flex>
                    <h2>Информация об автомобиле по базе ГИБДД.</h2>
                </v-flex>
            </v-layout>
            <v-layout
                class="service-form service-result-list"
                style="max-width: 1240px"
                v-if="!showMore"
            >
                <v-flex class="service-result-list-item">
                    <div>Марка и(или) модель</div>
                    <div v-html="requestResult.markModel"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Год выпуска</div>
                    <div v-html="requestResult.year"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Идентификационный номер (VIN)</div>
                    <div v-html="requestResult.vin"></div>
                </v-flex>
            </v-layout>
            <v-layout
                class="service-form service-result-list"
                style="max-width: 1240px"
                v-if="showMore"
            >
                <v-flex class="service-result-list-item">
                    <div>Марка и(или) модель</div>
                    <div v-html="requestResult.markModel"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Год выпуска</div>
                    <div v-html="requestResult.year"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Идентификационный номер (VIN)</div>
                    <div v-html="requestResult.vin"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Номер кузова (кабины)</div>
                    <div v-html="requestResult.bodyNumber"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Цвет кузова (кабины)</div>
                    <div v-html="requestResult.color"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Номер двигателя</div>
                    <div v-html="requestResult.engineNumber"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Рабочий объем (см³)</div>
                    <div v-html="requestResult.engineVolume"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Мощность (кВт/л.с)</div>
                    <div v-html="requestResult.powerHp + '/' + requestResult.powerKwt"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>Тип транспортного средства</div>
                    <div v-html="requestResult.type"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>ПТС серия и номер</div>
                    <div v-html="requestResult.number"></div>
                </v-flex>
                <v-flex class="service-result-list-item">
                    <div>ПТС выдан</div>
                    <div v-html="requestResult.issue"></div>
                </v-flex>
                <v-flex class="service-result-list-item service-result-note">
                    <h4>Регистрационные записи:</h4>
                    <v-flex v-for="(value, key) in requestResult.ownershipPeriods" :key="key" pt-3>
                        <span v-html="key+1 + '.'"></span> <span v-html="value"></span>
                    </v-flex>
                </v-flex>
            </v-layout>
            <v-layout
                class="service-form-button"
                style="max-width: 1240px"
            >
                <v-btn
                    class="button black-button block"
                    @click="showMore = true"
                    v-if="!showMore"
                >
                    Подробнее
                </v-btn>
                <v-btn
                    class="button black-button block"
                    @click="showMore = false"
                    v-if="showMore"
                >
                    Свернуть
                </v-btn>
            </v-layout>
            <v-layout
                pb-4
                class="service-form-button"
                style="max-width: 1240px"
            >
                <v-btn
                    class="button next-button block"
                    @click="resetResult"
                >
                    Назад
                </v-btn>
            </v-layout>
        </v-container>
        <services-underlist v-if="!b2b" />
        <services-list v-if="!b2b" />
    </v-app>
</template>
<script>
    import _ from 'lodash';
    import ServicesBreadcrumbs from "./ServicesBreadcrumbs";

    export default {
        components: {'services-breadcrumbs': ServicesBreadcrumbs},
        props: {
            b2b: {
                default: false
            }
        },
        data: () => ({
            loading: false,
            hasResult: false,
            requestResult: {
                markModel: null,
                year: null,
                vin: null,
                color: null,
                engineNumber: null,
                engineVolume: null,
                powerHp: null,
                powerKwt: null,
                type: null,
                number: null,
                issue: null,
                ownershipPeriods: null,
            },
            requestResultDefault: {},
            showMore: false,
            carouselSlides: [
                'Найдите информацию об автомобиле по гос. номеру или VIN коду.',
                'По истории регистрации авто Вы увидите реальное количество собственников.',
                'Рассчитайте ОСАГО на машину всего за 5 минут в 15 страховых компаниях.'
            ],
        }),
        created() {
            this.requestResultDefault = _.cloneDeep(this.requestResult)
        },
        methods: {

            find(data) {
                this.loading = true
                try {
                    grecaptcha.ready(() => {
                        grecaptcha.execute(
                            Vue.GetpolisConstants.RECAPTCHA_SITEKEY,
                            {action: Vue.GetpolisConstants.RECAPTCHA_ACTIONS.GIBDD}
                        ).then(token => {
                            data.r = token
                            axios.post('/services/getgibdd', data)
                            .then(response => {
                                this.hasResult = true
                                this.requestResult = response.data
                                window.scrollTo(0,0);
                            })
                            .catch(error => {
                                console.log(error)
                                PNotify.error(error.response.data.message);
                            })
                            .finally(() => {
                                this.$nextTick(() => {
                                    this.loading = false
                                })
                            })
                        });
                    })
                } catch (e) {
                    console.log(e);
                }
            },

            resetResult() {
                this.requestResult = _.cloneDeep(this.requestResultDefault)
                this.showMore = false
                this.hasResult = false
                window.scrollTo(0,0);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/services/ServiceGibddPage.vue